<template>
  <base-modal name="shareMeeting" width="540">
  <template #body>
    <div class="px-20 pb-40" v-if="meetingInfo">
      <div class="flex justify-between mt-40">
        <div class="title-description">
            <p v-if="meetingInfo.meeting_name"  class="truncate-name" dir="auto">
              {{ meetingInfo.meeting_name }}
            </p>
            <p v-else>{{ $t('busy') }}</p>
            <div>
            </div>
          </div>
        <close-icon @click.native="closeModals('shareMeeting')"/>
      </div>
      <div class="flex">
        <p v-if="isToday" :class="dateDirection">
          {{ newFormatDateStart }} {{ meetingInfo.started_at.slice(11, 16) }}
          -{{ meetingInfo.ended_at.slice(11, 16) }}</p>
        <p v-else  :class="dateDirection">
          {{ newFormatDateStart }} {{ meetingInfo.started_at.slice(11, 16) }}
          -{{ newFormatDateEnd }} {{ meetingInfo.ended_at.slice(11, 16) }}
        </p>
      </div>
    </div>
    <span class="mx-20">{{ $t('share_meeting_link') }}</span>
    <div class="mx-20 pt-10 flex justify-between">
      <div class="h-80 w-540 border border-default rounded-md flex items-center justify-between
       relative">
        <div class="flex items-center justify-between px-10">
          <div class="rounded-full w-40 h-40 flex items-center">
            <google />
          </div>
          <p class="text-subtitle">{{sharedLink}}</p>
        </div>
        <base-button
            class="m-18 share-button"
            @click.native="copyURL()"
            buttonType="info-opacity"
            width="70"
            height="40"
            radius="sm"
          >
            <template #text>
              <p class="text-sm font-bold">{{ $t('copy') }}</p>
            </template>
          </base-button>
        <div v-if="didCopy" class="tooltip-copy">
          <span>{{ $t('copied') }}</span>
        </div>
      </div>
    </div>
  </template>
  </base-modal>
</template>
<script>
import { mapGetters } from 'vuex';
import { OnImageError } from '@/utils/on-image-error';
import BaseButton from '@/components/base/BaseButton.vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import CloseIcon from '@/assets/icons/vue/close_normal.vue';
import Google from '../../assets/icons/vue/Google.vue';

export default {
  name: 'ShareMeeting',
  components: {
    BaseButton,
    BaseModal,
    Google,
    CloseIcon,
  },
  props: {
    meetingInfo: {
      type: Object,
    },
    newFormatDateStart: {
      type: String,
    },
    newFormatDateEnd: {
      type: String,
    },
    calendar: {
      type: String,
    },
  },
  data() {
    return {
      OnImageError,
      meetingInfoID: this.$route.params.reserveId,
      deviceId: this.$route.params.deviceId || this.meetingInfo.device_id,
      sharedLink: window.location.origin,
      didCopy: false,
      isToday: null,
    };
  },
  mounted() {
    this.checkToday();
    this.sharedLink = `${window.location.origin}/${localStorage.getItem('locale')}/m/${this.meetingInfo.meeting_code}`;
  },
  watch: {
    newFormatDateEnd() {
      this.checkToday();
    },
    meetingInfo() {
      this.sharedLink = `${window.location.origin}/${localStorage.getItem('locale')}/m/${this.meetingInfo.meeting_code}`;
    },
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme',
      defaultCompany: 'getDefaultCompany',
      currentPermission: 'permissions/getPermissions',
    }),
    dateDirection() {
      if (this.calendar === 'Solar' && (this.$i18n.locale !== 'fa' && this.$i18n.locale !== 'ar')) {
        return 'dir-rtl';
      }
      if (this.calendar === 'Gregorian' && (this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar')) {
        return 'dir-ltr';
      }
      if (this.calendar === 'Solar' && (this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar')) {
        return 'dir-rtl';
      }
      return 'dir-ltr';
    },
  },
  methods: {
    checkToday() {
      if (this.newFormatDateStart === this.newFormatDateEnd) {
      this.isToday = true;
    } else {
      this.isToday = false;
    }
    },
    copyURL() {
      navigator.clipboard.writeText(this.sharedLink);
      this.didCopy = true;
      setTimeout(() => {
        this.didCopy = false;
      }, 1000);
    },
    PopOver() {
      this.$emit('PopOver');
    },
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
  },
};
</script>
<style scoped>
.title-description {
  @apply text-title font-bold text-24;
}
.attendee-section {
  @apply bg-theme-secondary rounded;
}
.tooltip-copy {
  @apply absolute -bottom-20 right-10 bg-tertiary px-20 py-5 rounded-sm z-20;
}
.tooltip-copy:after {
  content: '';
  @apply absolute left-1/2 bottom-full -mt-5 border-4 border-solid;
  border-color: transparent transparent var(--color-bg-tertiary) transparent;
}
.tooltip-copy:is(:lang(fa), :lang(ar)) {
  @apply absolute -bottom-20 left-10 right-auto bg-tertiary px-20 py-5 rounded-sm z-20;
}
.tooltip-copy:is(:lang(fa), :lang(ar)):after {
  content: '';
  @apply absolute right-1/2 left-auto bottom-full -mt-5 border-4 border-solid;
  border-color: transparent transparent var(--color-bg-tertiary) transparent;
}
.share-button {
  @apply bg-primaryOpacity text-blueText border-none !important;
}
.dir-rtl {
  direction: rtl;
}
.dir-ltr {
  direction: ltr;
}
.truncate-name {
  @apply  truncate w-500 px-10;
}
</style>
